import { Injectable } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { TreeNode } from '@mirage-projects/cw-models';

/**
 * Service to handle the search function of the treeview.
 */
@Injectable()
export class TreeviewActionService {
    private readonly nodeRenameSubject$ = new ReplaySubject<TreeNode>(1);
    readonly nodeRename$ = this.nodeRenameSubject$.asObservable();

    private readonly searchTextSubject$ = new ReplaySubject<string>(1);
    readonly searchText$ = this.searchTextSubject$.asObservable();

    /**
     * Applys the search text on the treeview nodes and emits the text to be selected to the node views
     * @param data the treenode to apply the search on
     * @param text Text to be searched
     */
    applySearchText(data: TreeNode, text: string): void {
        this.updateTreeStatusBySearch(data, text);
        this.searchTextSubject$.next(text);
    }

    nodeRename(node: TreeNode): void {
        this.nodeRenameSubject$.next(node);
    }

    private updateTreeStatusBySearch<T>(node: TreeNode<T>, searchString: string): boolean {
        const hasStringInChildren = node.children
            .map((child) => !!this.updateTreeStatusBySearch(child, searchString))
            .some((hasString) => hasString);

        const hasStringInTitle = node.title.toLowerCase().includes(searchString.toLowerCase());
        const hasSearchString = hasStringInChildren || hasStringInTitle;

        node.visible = hasSearchString;
        node.collapsed = hasStringInTitle && !hasStringInChildren;

        return hasSearchString;
    }
}
